import { Link, type LinkProps } from 'react-router-dom';
import { entityLinkClassName } from '@/lib/entityLink';
import { cn } from '@/lib/utils';

/** Standard in-table link — same hover underline as Products list rows. */
export function TableLink({ className, ...props }: LinkProps) {
  return <Link {...props} className={cn(entityLinkClassName, className)} />;
}
